import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import localize from 'helpers/translator/localize'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Confirm from 'views/confirm/confirm'
import oeqActions from 'redux/actions/oeqActions'

const CustomAudioPlayerDeleteConfirm = props => (
	<Confirm
		alertMessage={localize('custom_audio_player_delete_confirm_text')}
		btOne={localize('custom_audio_player_delete_confirm_cancel')}
		btTwo={localize('custom_audio_player_delete_confirm_confirm')}
		actionOne={props.actions.cancel}
		actionTwo={props.actions.delete}
		actionButtonType={1}
		closeAction={props.actions.cancel}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		delete: oeqActions.confirmAudioPlayerDelete,
		cancel: oeqActions.cancelAudioPlayerDelete,
	}, dispatch)
}

CustomAudioPlayerDeleteConfirm.propTypes = {
	actions: PropTypes.shape({
		delete: PropTypes.func.isRequired,
		cancel: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(CustomAudioPlayerDeleteConfirm)

export { CustomAudioPlayerDeleteConfirm }
